export class MessageModel {
  message: string = 'success message'
}
